export default __webpack_public_path__ + "static/media/green.32c41330.svg";